import { ApiRx } from "@polkadot/api";
import { enrollStepV1 as wrappedEnrollStepV1 } from "../wrappers";
import { StepRetrySchema } from "./errorData";
import processRpcCall, { specialErrorPagesMapFn } from "./processRpcCall";

export type EnrollStepV1Response = Awaited<ReturnType<typeof enrollStepV1>>;

const errorMessageToSpecialErrorPage = {
  "server error: public key already used": "publicKeyAlreadyUsed",
  "server error: person already enrolled": "personAlreadyEnrolled",
  "validator key not available": "validatorKeyNotAvailable",
} as const;

const enrollStepV1 = async (
  api: ApiRx,
  requestBlob: string,
  context?: string,
) =>
  processRpcCall(
    () => wrappedEnrollStepV1(api, requestBlob, context),
    StepRetrySchema,
    specialErrorPagesMapFn(errorMessageToSpecialErrorPage),
  );

export default enrollStepV1;
